// extracted by mini-css-extract-plugin
module.exports = {"hero":"index_hero_dL5ez"};